import { AlignmentType } from "docx";
import type { ResumeTemplateDefinition } from "./types";
import { createDocxResumeDocument } from "./docx-builder";
import { ResumePdfTemplateDocument } from "./pdf-builder";

export const templateTwo: ResumeTemplateDefinition<"template-2"> = {
  id: "template-2",
  label: "Borealis Flow",
  description:
    "Glow-filled timeline layout tracing your journey with cyan aurora accents.",
  accentColor: "#0ea5e9",
  render: (resume) =>
    createDocxResumeDocument(resume, {
      accentColor: "#0ea5e9",
      headingFont: "Calibri Light",
      bodyFont: "Inter",
      headerAlignment: AlignmentType.LEFT,
      headingTransform: "uppercase",
      includeOrganizations: true,
      includeHighlights: true,
      contactSeparator: " · ",
      bulletSpacing: 90,
      nameFontSize: 26,
    }),
  renderPdf: (resume) => (
    <ResumePdfTemplateDocument
      resume={resume}
      options={{
        accentColor: "#0ea5e9",
        headingFont: "Calibri Light",
        bodyFont: "Inter",
        headerAlignment: "left",
        headingTransform: "uppercase",
        includeOrganizations: true,
        includeHighlights: true,
        contactSeparator: " · ",
        bulletSpacing: 90,
        nameFontSize: 26,
      }}
    />
  ),
};
